import { Button } from '../';
import { ButtonGroup } from '@urbaninfrastructure/react-ui-kit';

type Props = {
  page?: number;
  onPrevClick?: () => void;
  isPrevDisabled?: boolean;
  onNextClick?: () => void;
  isNextDisabled?: boolean;
  buttonGroupProps?: any;
};

export const TablePager = ({
  page = 1,
  onPrevClick,
  isPrevDisabled = false,
  onNextClick,
  isNextDisabled = false,
  buttonGroupProps
}: Props) => {
  return (
    <ButtonGroup segment {...(buttonGroupProps || {})}>
      <Button
        small
        disabled={isPrevDisabled}
        onClick={onPrevClick}
        data-testid="Pager__Prev"
      >
        {'<'}
      </Button>
      <Button disabled small data-testid="Pager__Page">
        {page}
      </Button>
      <Button
        small
        disabled={isNextDisabled}
        onClick={onNextClick}
        data-testid="Pager__Next"
      >
        {'>'}
      </Button>
    </ButtonGroup>
  );
};
